"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var r,
    e = require("apollo-link-http"),
    t = require("apollo-link-context"),
    n = (r = require("prismic-javascript")) && "object" == typeof r && "default" in r ? r.default : r;

function o(r, e, t) {
  return e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}

function i(r, e) {
  var t = Object.keys(r);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(r, e).enumerable;
    })), t.push.apply(t, n);
  }

  return t;
}

function c(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = null != arguments[e] ? arguments[e] : {};
    e % 2 ? i(Object(t), !0).forEach(function (e) {
      o(r, e, t[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : i(Object(t)).forEach(function (e) {
      Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(t, e));
    });
  }

  return r;
}

function a(r, e) {
  if (null == r) return {};

  var t,
      n,
      o = function (r, e) {
    if (null == r) return {};
    var t,
        n,
        o = {},
        i = Object.keys(r);

    for (n = 0; n < i.length; n++) {
      t = i[n], e.indexOf(t) >= 0 || (o[t] = r[t]);
    }

    return o;
  }(r, e);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(r);

    for (n = 0; n < i.length; n++) {
      t = i[n], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(r, t) && (o[t] = r[t]);
    }
  }

  return o;
}

function u(r, e) {
  return function (r) {
    if (Array.isArray(r)) return r;
  }(r) || function (r, e) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(r))) return;
    var t = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var c, a = r[Symbol.iterator](); !(n = (c = a.next()).done) && (t.push(c.value), !e || t.length !== e); n = !0) {
        ;
      }
    } catch (r) {
      o = !0, i = r;
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw i;
      }
    }

    return t;
  }(r, e) || function (r, e) {
    if (!r) return;
    if ("string" == typeof r) return s(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    "Object" === t && r.constructor && (t = r.constructor.name);
    if ("Map" === t || "Set" === t) return Array.from(r);
    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return s(r, e);
  }(r, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function s(r, e) {
  (null == e || e > r.length) && (e = r.length);

  for (var t = 0, n = new Array(e); t < e; t++) {
    n[t] = r[t];
  }

  return n;
}

var l = /^https?:\/\/([^.]+)\.(?:cdn\.)?(wroom\.(?:test|io)|prismic\.io)\/graphql\/?/;

function f(r) {
  var o,
      i,
      s = r.uri,
      f = r.accessToken,
      p = r.repositoryName,
      y = a(r, ["uri", "accessToken", "repositoryName"]),
      m = function (r) {
    var e = r.match(l);

    if (null !== e && Array.isArray(e) && 3 === e.length) {
      var t = u(e, 3),
          n = t[1],
          o = t[2];
      return "https://".concat(n, ".cdn.").concat(o);
    }

    return null;
  }(s);

  if (m && p && console.warn("`repositoryName` is ignored since the graphql endpoint is valid."), !m && !p) throw Error("Since you are using a custom GraphQL endpoint, you need to provide to PrismicLink your repository name as shown below:\nPrismicLink({\n  uri: 'https://mycustomdomain.com/graphql',\n  accessToken: 'my_access_token', // could be undefined\n  repositoryName: 'my-prismic-repository'\n})\n");
  m ? (o = "".concat(m, "/api"), i = "".concat(m, "/graphql")) : (o = "https://".concat(p, ".cdn.prismic.io/api"), i = s);
  var b = n.client(o, {
    accessToken: f
  }),
      d = t.setContext(function (r, e) {
    return b.getApi().then(function (r) {
      return {
        headers: c(c(c({
          "Prismic-ref": r.masterRef.ref
        }, e.headers), r.integrationFieldRef ? {
          "Prismic-integration-field-ref": r.integrationFieldRef
        } : {}), f ? {
          Authorization: "Token ".concat(f)
        } : {})
      };
    });
  }),
      h = new e.HttpLink(c({
    uri: i,
    useGETForQueries: !0,
    fetch: function (r) {
      function e() {
        return r.apply(this, arguments);
      }

      return e.toString = function () {
        return r.toString();
      }, e;
    }(function (r, e) {
      var t = function (r) {
        var e = u(r.split("?"), 2),
            t = e[0],
            n = e[1];
        return n ? [t, n.split("&").map(function (r) {
          var e = u(r.split("="), 2),
              t = e[0],
              n = e[1];
          return "query" === t ? t + "=" + n.replace(/(%0A|%20)*(%20|%7B|%7D)(%0A|%20)*/g, function (r, e, t) {
            return t;
          }) : r;
        }).join("&")].join("?") : r;
      }(r);

      return fetch(t, e);
    })
  }, y));
  return d.concat(h);
}

var p = {
  PrismicLink: f
};
exports.PrismicLink = f, exports.default = p;